import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import s from './radio.module.scss';
export var Radio = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, label = _a.label, name = _a.name;
    return (_jsxs("label", { className: s.wrapper, children: [_jsx("input", { type: "radio", checked: checked, onChange: onChange, name: name, className: s.input }), _jsx("span", { className: s.radio }), label && _jsx("span", { className: s.label, children: label })] }));
};
